import { observable, configure, action } from 'mobx';
import util from 'preact-util';
import LocalModel from './localModel';

configure({ enforceActions: 'always' });

class PartMaintenanceStore extends LocalModel {
    constructor() {
        super('partMaintenance', {
            namePlural: 'partMaintenances',
            namePluralReal: 'partmaintenances',
            sort: '-createdDate',
            limit: 50,
            api: {
                search: {
                    url: '/api/partmaintenances/',
                    params: {},
                },
                load: {
                    url: '/api/partmaintenances/',
                    params: {},
                },
                save: {
                    url: '/api/partmaintenances/',
                    params: {},
                },
                delete: {
                    url: '/api/partmaintenances/',
                    params: {},
                },
            },
        });
    }

    @observable weapons = [];

    @observable weapon = {};

    @observable timeline = [];

    @observable canEdit = false;

    @observable isLoading = false;

    @observable lastError = '';

    @action
    async loadWeapons() {
        this.updateKeyValue('isLoading', true);
        const response = await util.fetchApi('/api/partmaintenances/weapons', { method: 'GET' }, {});
        if (response?.status === 200) {
            this.updateKeyValue('weapons', response.data || []);
        }
        this.updateKeyValue('isLoading', false);
        return response;
    }

    @action
    async loadScan(uuidv4) {
        this.updateKeyValue('isLoading', true);
        const response = await util.fetchApi(`/api/partmaintenances/scan/${uuidv4}`, { method: 'GET' }, {});
        if (response?.status === 200) {
            const data = response.data || {};
            this.updateKeyValue('weapon', data.weapon || {});
            this.updateKeyValue('timeline', data.timeline || []);
            this.updateKeyValue('canEdit', !!data.canEdit);
        }
        this.updateKeyValue('isLoading', false);
        return response;
    }

    @action
    async addEvent(input = {}) {
        const {
            part, type, date, note, installation,
        } = input;
        const response = await util.fetchApi('/api/partmaintenances/', { method: 'POST' }, {
            part, type, date, note, installation,
        });
        if (response?.status === 201) {
            this.updateKeyValue('lastError', '');
            if (this.weapon?.uuidv4) {
                await this.loadScan(this.weapon.uuidv4);
            }
        } else {
            this.updateKeyValue('lastError', response?.message || 'Could not save');
        }
        return response;
    }

    @action
    async setStorage(partId, installationId) {
        // storageInstallation is a numeric relation field — clearing it must send 0, never ''
        // (see CLAUDE.md: removing numeric relations sets 0, not null/empty string).
        const storageInstallation = parseInt(installationId, 10) || 0;
        const response = await util.fetchApi(`/api/parts/${partId}`, { method: 'PATCH' }, { storageInstallation });
        if (response?.status === 202 || response?.status === 200) {
            this.updateKeyValue('lastError', '');
        } else {
            this.updateKeyValue('lastError', response?.message || 'Could not save');
        }
        await this.loadWeapons();
        return response;
    }

    @action
    async returnLoan(loanId) {
        const response = await util.fetchApi(`/api/parts/loan/${loanId}/return`, { method: 'PATCH' }, {});
        if (response?.status === 202 || response?.status === 200) {
            this.updateKeyValue('lastError', '');
        } else {
            this.updateKeyValue('lastError', response?.message || 'Could not save');
        }
        if (this.weapon?.uuidv4) {
            await this.loadScan(this.weapon.uuidv4);
        }
        return response;
    }
}

const store = new PartMaintenanceStore();
export default store;
